import { usePortfolio } from '../../context/PortfolioContext';
import { motion } from 'framer-motion';
import Modal from '../Modal';
import { FaRegLightbulb } from 'react-icons/fa';
import React, { useState } from 'react';

const Patents = () => {
  const { portfolioData, loading } = usePortfolio();
  const patentsData = portfolioData?.patents || [];
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPatent, setSelectedPatent] = useState(null);

  if (loading) {
    return (
      <div className="animate-pulse space-y-6">
        <div className="h-6 bg-gray-700 w-1/3 rounded"></div>
        {[1, 2, 3].map((index) => (
          <div key={index} className="space-y-3 bg-gray-800 p-6 rounded-lg">
            <div className="h-5 bg-gray-700 w-3/4 rounded"></div>
            <div className="h-4 bg-gray-700 w-full rounded"></div>
            <div className="h-4 bg-gray-700 w-5/6 rounded"></div>
            <div className="h-4 bg-gray-700 w-1/4 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const visiblePatents = patentsData.filter(patent => patent.visible !== false);

  const openModal = (patent) => {
    setSelectedPatent(patent);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setSelectedPatent(null);
  };

  return (
    <div className="py-8">
      <h3 className="text-2xl font-semibold text-white mb-8 flex items-center gap-3">
        <FaRegLightbulb className="text-primary" />
        Patents
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {visiblePatents.map((patent, index) => (
          <motion.div 
            key={patent.id}
            className="bg-secondary/30 p-6 rounded-lg border border-primary/10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <h4 className="text-xl font-medium text-white mb-3">{patent.title}</h4>
            <p className="text-gray-300 mb-4">{patent.summary || patent.description}</p>
            {patent.filedDate && (
              <div className="flex flex-wrap justify-between text-sm">
                <span className="text-gray-400">
                  Filed: <span className="text-primary">{patent.filedDate}</span>
                </span>
                <span className={`px-3 py-1 rounded-full ${
                  patent.patentStatus === "Patent Granted" 
                    ? "bg-green-900/30 text-green-400" 
                    : "bg-yellow-900/30 text-yellow-400"
                }`}>
                  {patent.patentStatus}
                </span>
              </div>
            )}
            {patent.applicationNumber && (
              <div className="mt-3 text-sm text-gray-500">
                Application: {patent.applicationNumber}
              </div>
            )}
            <button
              onClick={() => openModal(patent)}
              className="text-primary hover:underline mt-2"
            >
              View Details
            </button>
          </motion.div>
        ))}
      </div>
      {selectedPatent && (
        <Modal
          isOpen={modalOpen}
          onClose={closeModal}
          title={selectedPatent.title}
          content={
            <div>
              <p className="mb-4">{selectedPatent.description}</p>
              {selectedPatent.authors && (
                <div className="mb-2 text-sm text-gray-400">
                  <strong>Authors:</strong> {selectedPatent.authors.join(', ')}
                </div>
              )}
              {selectedPatent.date && (
                <div className="mb-2 text-sm text-gray-400">
                  <strong>Date:</strong> {selectedPatent.date}
                </div>
              )}
              {selectedPatent.image_url && (
                <img src={selectedPatent.image_url} alt="Patent" className="mt-2 h-32 rounded" />
              )}
            </div>
          }
        />
      )}
    </div>
  );
};

export default Patents; 